(() => {
  const SECTION_SELECTOR = '.shopify-section--main-product';
  const RELATED_SELECTOR = '.shopify-section--related-products';
  const MOBILE_QUERY = '(max-width: 749px)';
  const mediaQuery = window.matchMedia(MOBILE_QUERY);
  let scheduled = false;

  function ensureRelatedAnchor(related) {
    const parent = related && related.parentElement;
    if (!parent) return null;

    let anchor = parent.querySelector(':scope > [data-lyla-cro-related-anchor]');
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
      anchor.dataset.lylaCroRelatedAnchor = '';
      related.before(anchor);
    }
    return anchor;
  }

  function placeAfter(referenceNode, node) {
    if (!referenceNode || !node || referenceNode.nextElementSibling === node) return;
    referenceNode.insertAdjacentElement('afterend', node);
  }

  function markProductSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      section.classList.add('lyla-cro-v1');
      section.dataset.lylaCro = 'mobile-pdp-v3';
    });
  }

  function enhanceSectionOrder() {
    const mainProduct = document.querySelector(SECTION_SELECTOR);
    const related = document.querySelector(RELATED_SELECTOR);
    if (!mainProduct || !related || mainProduct.parentElement !== related.parentElement) return;

    const anchor = ensureRelatedAnchor(related);
    if (!anchor) return;

    if (mediaQuery.matches) {
      placeAfter(mainProduct, related);
      related.dataset.lylaCroPromoted = 'true';
    } else {
      placeAfter(anchor, related);
      delete related.dataset.lylaCroPromoted;
    }
  }

  function run() {
    /* Important: do not reorder any blocks inside product-info. Shopify's original PDP order stays intact. */
    markProductSections();
    enhanceSectionOrder();
  }

  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function start() {
    run();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', scheduleRun);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(scheduleRun);
    }

    document.addEventListener('shopify:section:load', scheduleRun);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
